// src/features/dashboard/components/ManagerDashboard/AtRiskAssociate/RiskByTeamChart.tsx

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  LabelList,
  Tooltip,
} from 'recharts';

type TeamChartItem = {
  team: string;
  count: number;
};

type Props = {
  data: TeamChartItem[];
  error?: string | null;
};


type TooltipProps = {
  active?: boolean;
  payload?: Array<{
    payload: TeamChartItem;
  }>;
};


const CustomTooltip = ({
  active,
  payload,
}: TooltipProps) => {

  if (
    !active ||
    !payload ||
    payload.length === 0
  ) {
    return null;
  }

  const item =
    payload[0].payload;

  return (
    <div
      className="
        rounded-md
        border
        border-slate-300
        bg-white
        px-3
        py-2
        shadow-md
      "
    >

      <p
        className="
          text-[12px]
          font-semibold
          text-slate-800
        "
      >
        {item.team}
      </p>

      <p
        className="
          mt-1
          text-[11px]
          text-orange-600
        "
      >
        Associate :

        <span className="ml-1 font-semibold">
          {item.count}
        </span>
      </p>

    </div>
  );
};


const RiskByTeamChart = ({
  data,
  error,
}: Props) => {

  if (error) {

    return (
      <div
        className="
          flex
          h-[300px]
          items-center
          justify-center
          rounded-2xl
          border
          border-red-200
          bg-white
          p-4
        "
      >
        <p
          className="
            font-medium
            text-red-600
          "
        >
          {error}
        </p>
      </div>
    );
  }


  if (
    !data ||
    data.length === 0
  ) {

    return (
      <div
        className="
          flex
          h-[300px]
          items-center
          justify-center
          rounded-2xl
          border
          border-slate-200
          bg-white
          p-4
        "
      >
        <p className="text-slate-500">
          No Risk By Team data available.
        </p>
      </div>
    );
  }


  return (
    <div
      className="
        h-[300px]
        rounded-2xl
        border
        border-slate-200
        bg-white
        p-4
      "
    >

      {/* Header */}

      <div
        className="
          mb-3
          flex
          items-center
          gap-2
        "
      >

        <h3
          className="
            text-[15px]
            font-semibold
            text-[#003E7E]
          "
        >
          Risk by Team
        </h3>

        <span
          className="
            rounded-full
            bg-blue-50
            px-3
            py-1
            text-[10px]
            text-blue-600
          "
        >
          At-risk count per TL
        </span>

      </div>


      <ResponsiveContainer
        width="100%"
        height={220}
      >

        <BarChart
          data={data}
          margin={{
            top: 5,
            right: 10,
            left: -15,
            bottom: 0,
          }}
        >

          <CartesianGrid
            vertical={false}
            strokeDasharray="3 3"
            stroke="#e5e7eb"
          />


          <XAxis
            dataKey="team"
            axisLine={false}
            tickLine={false}
            tick={{
              fontSize: 11,
              fill: '#475569',
            }}
          />


          <YAxis
            allowDecimals={false}
            axisLine={false}
            tickLine={false}
            tick={{
              fontSize: 11,
              fill: '#475569',
            }}
          />


          <Tooltip
            cursor={{
              fill:
                'rgba(0,0,0,0.04)',
            }}
            content={
              <CustomTooltip />
            }
          />


          <Bar
            dataKey="count"
            fill="#f78b35"
            radius={[
              6,
              6,
              0,
              0,
            ]}
            barSize={28}
          >

            <LabelList
              dataKey="count"
              position="center"
              fill="#ffffff"
              fontSize={12}
              fontWeight={600}
            />

          </Bar>

        </BarChart>

      </ResponsiveContainer>

    </div>
  );
};


export default RiskByTeamChart;